import { set, uniq } from "ramda"
import { useFetchStories } from "./context/useFetchStories"
import { useEffect, useState, useMemo } from "react"
import BerfButton from "./common/BerfButton"
import ffmpeg from './utils/ffmpeg'
import VideoPlayer from "./VideoPlayer2"
import { FaRegTrashAlt, FaLongArrowAltUp } from "react-icons/fa";

export default function TripViewer ({ trip = [], setTrip, storyId }) {
  const { fetchStories, storiesCache, nodesCache, videosCache } = useFetchStories() 
  const [videoSrc, setVideoSrc] = useState(null)
  const [generating, setGenerating] = useState(false)
  const tripWithStory = useMemo(() => [...trip, storyId], [trip, storyId]);
  useEffect(() => {
    fetchStories(tripWithStory)
  }, [fetchStories, tripWithStory])
  const theTrip = uniq(tripWithStory)
  let btn = (
    generating ? 'Generating...' : <BerfButton onClick={async () => {
      setGenerating(true)
      const videos = theTrip.map(t => videosCache[storiesCache[t].videoId].video)
      const d = await ffmpeg.concatMp4s(videos)
      setVideoSrc(URL.createObjectURL(new Blob([d.buffer], {type: 'video/mp4'})))
      setGenerating(false)
    }}>generate</BerfButton>
  )
  if (videoSrc) {
    btn = (
      <a href={videoSrc} className='btn' download>download</a>
    )
  }
  return (
    <div className="trip-viewer">
      {videoSrc && (
        <div className="mb-4">
          <VideoPlayer className='mb-2' url={videoSrc} />
        </div>

      )}
      <div className="trip mt-4">
        {theTrip.map((t, i) => {
          const story = storiesCache[t] 
          const video = videosCache[story.videoId] 
          const node = story && nodesCache[story.nodeId] 
          const screenshot = 'https://aiaiaiaiai.biz/' + video.images.find(i => /screenshot/.test(i))
          return (
            <div key={t}>
              <img src={screenshot} />
              <p>{(node && node.text) || video.summary}</p>
              {i < theTrip.length - 1 && <a className='ml-auto pr-2 pl-6 flex' onClick={() => {
                setTrip([...trip.slice(i + 1)])
                setVideoSrc(null)
              }}><FaRegTrashAlt />{i > 0 && <FaLongArrowAltUp />}</a>}
            </div>
          )
        })}
      </div>
      <div className='btn-wrap absolute bottom-4'>
        {btn}
      </div>
    </div>
  )
}